import React from "react";
import withStyles from "components/with-styles";
import styles from "./styles/page-content-wrapper.css.js";

const PageContentWrapper = ({ classes, children }) => <div className={classes.page_content_wrapper}>{children}</div>;

export default withStyles(styles)(PageContentWrapper);
